import { stringify } from 'query-string';
import { TEMPLATE_ID } from 'helpers/interceptors/certificationsInterceptor';

export interface IGetLatestCertificates {
  limit: number;
  offset: number;
  countryId?: string;
  sortOrder?: string;
  sortBy?: string;
}
export default function getLatestCertificatesUrl(
  args: IGetLatestCertificates
): string {
  const {
    countryId,
    limit,
    offset,
    sortOrder = 'desc',
    sortBy = 'certification_date',
  } = args;

  const countryParams = countryId
    ? {
        elementIdFilterKey: 'certification_country',
        elementValueFilter: countryId,
      }
    : {};

  const params = stringify({
    limit,
    offset,
    sortOrder,
    sortBy,
    ...countryParams,
  });

  return `api/annotations/all/templates/${TEMPLATE_ID}?${params}`;
}
